module.exports = __webpack_public_path__ + "img/hawaiian.96a9b82c.png";